import { Tooltip, tooltipClasses } from "@mui/material"
import { useRef } from "react"
//import { withStyles } from '@mui/styles'

// NOTE: when using <LightTooltip> surround the children with <div></div> so that passed css classes
// of the children are properly applied
export const LightTooltip = (props => {
	//console.debug("tooltip props=", props)
	// MTVW-917: default "top" -> "bottom"
	// NOTE: Fullscreen depends on the screen aspect ratio. If the aspect ratio is 16:9 there is not enough
	// place for the tooltip below the player controls.If there is more height, e.g.with aspect ratio 16: 10,
	// the tooltips will be displayed below the player controls.
	//console.debug("LightTooltip", props, props?.isDisabled, props?.title)
	// MTVW-723, MTVW-950: check for valid props
	if (!props || !props.title || !props.children) return props?.children ?? <></>
	if (props?.isDisabled) return props?.children
	// no spread {...props}, props.isDisabled would generate a warning in Tooltip
	
	// fixes tooltip misplacement at bottom in fullscreen mode
	const boundingElement = useRef()
	
	return (
		<div ref={boundingElement}>
			<Tooltip arrow /*followCursor*/ placement={props.placement ?? "bottom"} title={props.title} children={props.children}
				// deprecated	
				//PopperProps={{ container: document.fullscreenElement ?? document.body, }}
				slotProps={{
					disablePortal: true,
					popper: {
						container: document.fullscreenElement ?? document.body,
						/*
						sx: {
							[`& .${tooltipClasses.tooltip}`]: {
								backgroundColor: "#FFFFFF", //(theme) => theme.palette.common.black
								color: "#000"
							},
							[`& .${tooltipClasses.arrow}`]: {
								color: "#FFFFFF" //(theme) => theme.palette.common.black
							},
						},
						*/
						modifiers: [
							{
								name: "offset",
								options: {
									offset: [props.offsetX ?? 0, -10],
								},
							},
							{
								name: "flip",
								enabled: false, // prevent flipping above
							},
							{
								name: "preventOverflow",
								options: {
									//altAxis: true, // allow shifting on the X-axis
									//tether: false,
									boundary: boundingElement.current ?? undefined,
								},
							},
						],
					},
				}}
			/>
		</div>
	)
})

/*
const LightTooltip = withStyles(theme => ({
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: 'rgba(0, 0, 0, 0.87)',
		boxShadow: theme.shadows[1],
		fontSize: 11,
	},
}))(Tooltip)
*/
